var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"theme-toggle",on:{"click":_vm.toggleTheme}},[_c('el-tooltip',{attrs:{"content":_vm.isDark ? '切换到浅色模式' : '切换到深色模式',"placement":"bottom"}},[_c('div',{staticClass:"toggle-btn",class:{ 'is-dark': _vm.isDark }},[_c('i',{class:_vm.isDark ? 'el-icon-sunny' : 'el-icon-moon'})])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33fd630c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/ThemeToggle.vue
// module id = null
// module chunks = 